(function () {
  'use strict';

  var START = Date.parse('2026-10-06T04:00:00Z');
  var END = Date.parse('2026-10-08T04:00:00Z');
  var TIERS = [
    { threshold: 12500, reward: 2000 },
    { threshold: 17500, reward: 3500 },
    { threshold: 25000, reward: 6000 }
  ];
  var ROOT_CLASS = 'tones-tier-progress';
  var preview = new URLSearchParams(window.location.search).get('tones_tier_preview') === '1';
  var timer = null;
  var lastSubtotal = null;

  function active() {
    var now = Date.now();
    return preview || (now >= START && now < END);
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function state(subtotal) {
    if (subtotal < TIERS[0].threshold) {
      return {
        earned: 0,
        next: TIERS[0],
        message: 'Add <strong>' + money(TIERS[0].threshold - subtotal) + '</strong> more to unlock <strong>$20 off</strong>.'
      };
    }
    if (subtotal < TIERS[1].threshold) {
      return {
        earned: 1,
        next: TIERS[1],
        message: '<strong>$20 off unlocked!</strong> Add <strong>' + money(TIERS[1].threshold - subtotal) + '</strong> more to unlock <strong>$35 off</strong>.'
      };
    }
    if (subtotal < TIERS[2].threshold) {
      return {
        earned: 2,
        next: TIERS[2],
        message: '<strong>$35 off unlocked!</strong> Add <strong>' + money(TIERS[2].threshold - subtotal) + '</strong> more to unlock <strong>$60 off</strong>.'
      };
    }
    return {
      earned: 3,
      next: null,
      message: '<strong>$60 off unlocked—our best Deal Days offer!</strong>'
    };
  }

  function markup() {
    return '<div class="' + ROOT_CLASS + '__message" aria-live="polite"></div>' +
      '<div class="' + ROOT_CLASS + '__track" aria-hidden="true"><span class="' + ROOT_CLASS + '__fill"></span>' +
      '<i style="left:50%"></i><i style="left:70%"></i><i style="left:100%"></i></div>' +
      '<div class="' + ROOT_CLASS + '__labels" aria-hidden="true"><span>$20 off</span><span>$35 off</span><span>$60 off</span></div>';
  }

  function containers() {
    var found = [];
    document.querySelectorAll('[data-drawer-body]').forEach(function (node) {
      found.push(node);
    });
    document.querySelectorAll('[data-cart-wrapper] .yv-cart-content-box').forEach(function (node) {
      found.push(node);
    });
    return found;
  }

  function ensure(container) {
    var bar = container.querySelector('.' + ROOT_CLASS);
    if (!bar) {
      bar = document.createElement('div');
      bar.className = ROOT_CLASS;
      bar.setAttribute('data-tones-tier-progress', '');
      bar.innerHTML = markup();
      container.insertBefore(bar, container.firstChild);
    }
    return bar;
  }

  function render(subtotal) {
    if (!active()) {
      document.querySelectorAll('.' + ROOT_CLASS).forEach(function (node) { node.remove(); });
      return;
    }
    var current = state(subtotal);
    var percentage = Math.min(100, Math.max(0, subtotal / TIERS[2].threshold * 100));
    containers().forEach(function (container) {
      var bar = ensure(container);
      bar.querySelector('.' + ROOT_CLASS + '__message').innerHTML = current.message;
      bar.querySelector('.' + ROOT_CLASS + '__fill').style.width = percentage + '%';
      bar.querySelectorAll('.' + ROOT_CLASS + '__labels span').forEach(function (label, index) {
        label.classList.toggle('is-earned', index < current.earned);
      });
      bar.classList.toggle('is-complete', current.earned === 3);
    });
    lastSubtotal = subtotal;
  }

  function readCart() {
    if (!active()) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var subtotal = Number(cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0);
        render(subtotal);
      })
      .catch(function () {});
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(readCart, delay || 80);
  }

  function relevantMutation(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    return !target || !target.closest || !target.closest('.' + ROOT_CLASS);
  }

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(relevantMutation)) schedule(120);
  });

  function init() {
    if (!active()) return;
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('[data-cart-wrapper], [data-drawer-body]')) schedule(350);
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.ajaxcart__qty--plus,.ajaxcart__qty--minus,.sd_mini_removeproduct,[data-cart-form] button,[name="add"]')) schedule(550);
    });
    readCart();
  }

  var style = document.createElement('style');
  style.id = 'tones-tier-progress-styles';
  style.textContent =
    '.tones-tier-progress{margin:0 0 18px;padding:16px 18px;background:#fff7f7;border:1px solid #fcc9c9;color:#111;font:500 13px/1.4 Arial,sans-serif}' +
    '.tones-tier-progress__message{min-height:19px;text-align:center}.tones-tier-progress__message strong{font-weight:800}' +
    '.tones-tier-progress__track{position:relative;height:9px;margin:13px 7px 8px;border-radius:999px;background:#e8e8e8}' +
    '.tones-tier-progress__fill{display:block;height:100%;width:0;border-radius:inherit;background:#fcc9c9;transition:width .35s ease}' +
    '.tones-tier-progress__track i{position:absolute;top:50%;width:15px;height:15px;border:2px solid #fff;border-radius:50%;background:#bbb;transform:translate(-50%,-50%);box-shadow:0 0 0 1px #aaa}' +
    '.tones-tier-progress__labels{display:flex;justify-content:space-between;gap:8px;font-size:10px;font-weight:700;color:#707070}' +
    '.tones-tier-progress__labels span.is-earned,.tones-tier-progress.is-complete .tones-tier-progress__labels span{color:#111}' +
    '.tones-tier-progress.is-complete{background:#f6fff6;border-color:#a9d3a9}.tones-tier-progress.is-complete .tones-tier-progress__fill{background:#6eaa70}' +
    '@media(max-width:480px){.tones-tier-progress{margin-bottom:14px;padding:14px 12px}.tones-tier-progress__message{font-size:12px}.tones-tier-progress__labels{font-size:9px}}' +
    '@media(prefers-reduced-motion:reduce){.tones-tier-progress__fill{transition:none}}';
  document.head.appendChild(style);

  window.TonesTierProgress = { render: render, refresh: readCart, state: state, tiers: TIERS };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
